<template>
  <BQdtCard
    name="comparisonHelp"
    type="help"
  />
</template>

<script>
import { BQdtCard } from '@/components/blocks'

export default {
  name: 'ComparisonHelp',

  components: { BQdtCard },
}
</script>
